<template>
  <div>
      <v-icon medium color="grey darken-2" style="margin-right:4px"> mdi-tune </v-icon>
   <v-icon
   color="grey"
   >
   mdi-message-text
 </v-icon>

                
                
       


 
</div>
</template>
<script>
  export default {
    data(){
     return {
      item:"Open",
      issueDialog:false,
      showtextArea:false,
      items: ['Resolved','Open'],
      rowData: null
    }
  },
  methods: {

    showCommentBox(){
     this.issueDialog=true;
     this.showtextArea=false
   },
   getValueToDisplay(params) {
    return params.valueFormatted ? params.valueFormatted : params.data;
            //return params.valueFormatted;
          }
        },
        beforeMount() {

          this.rowData = this.getValueToDisplay(this.params);
        },
      }
    </script>